import api from "../..";
import { uploadFile } from "../../file/uploadFile";
import type { Banner, PostBannerBody, PostBannerParams } from "./types";
import type { ApiResponse } from "../../types";

export const postBanner = async ({ title, description, related_content, desktopCoverFile, phoneCoverFile }: PostBannerParams): Promise<boolean> => {

  const desktopKey = await uploadFile({
    file: desktopCoverFile,
    signBody: {
      item_type: "course",
      item_id: Date.now(),
      object_name: desktopCoverFile.name,
      object_type: "image",
      object_size: desktopCoverFile.size,
    },
  });

  const phoneKey = await uploadFile({
    file: phoneCoverFile,
    signBody: {
      item_type: "course",
      item_id: Date.now(),
      object_name: phoneCoverFile.name,
      object_type: "image",
      object_size: phoneCoverFile.size,
    },
  });

  const body: PostBannerBody = {
    title,
    description,
    related_content,
    desktop_cover_image: desktopKey!,
    phone_cover_image: phoneKey!,
  };

  return await api.post<ApiResponse<Banner>>("admin/banner/", body)
  .then(() => true)
  .catch(() => false);
};